// extracted by mini-css-extract-plugin
export default {"home":"home_home__1jket","textSection":"home_textSection__NnAG1","button":"home_button__LT0gj","imageSection":"home_imageSection__sUhWh","image":"home_image__m+eba"};